import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BasicResponse} from '../core/interfaces/basic-response';

const API_URL = environment.apiUrl;
const API_VERSION = environment.MSReadingMEPOVersion;
const SERVICE = 'msreadingmepo-dot-';
const SERVICE_API_URL = `https://${API_VERSION}${SERVICE}${API_URL}`;

// const SERVICE_API_URL = 'http://localhost:8080/api/reading/';

@Injectable({
  providedIn: 'root'
})
export class ReadingMEPOService {

  constructor(private http: HttpClient) { }

  getNumberOfAvailableReadings(studyId, readerId): Observable<BasicResponse<number>> {
    return this.http.get<BasicResponse<any>>(`${SERVICE_API_URL}/readings/available-count/studyId-${studyId}/readerId-${readerId}`);
  }

  getAvailableReadings(studyId, readerId): Observable<BasicResponse<any>> {
    return this.http.get<BasicResponse<any>>(`${SERVICE_API_URL}/readings/available/studyId-${studyId}/readerId-${readerId}`);
  }

  getReading(studyId, readerId, readingId): Observable<BasicResponse<any[]>> {
    return this.http.get<BasicResponse<any[]>>(`${SERVICE_API_URL}/readings/studyId-${studyId}/readerId-${readerId}/${readingId}`);
  }

  startReading(readingId): Observable<BasicResponse<any>> {
    return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/start`, null);
  }

  updateReading(readingId, spentSeconds): Observable<BasicResponse<any>> {
    return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/log-time`, spentSeconds);
  }

  completeReading(readingId, reading: any, jwtToken): Observable<BasicResponse<any>> {
    const customHeader = new HttpHeaders({
      'Authorization': `Bearer ${jwtToken}`
    });
    return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/complete`, reading, {
      headers: customHeader
    });
  }
  
  lockTimepoint(studyId, visitId, model, jwtToken) {
    const customHeader = new HttpHeaders({
      'Authorization': `Bearer ${jwtToken}`
    });
    return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/visits/${visitId}`, model, { headers: customHeader });
  }

  updateTimepoint(studyId, visitId, model) {
    const customHeader = new HttpHeaders({
      'Authorization': `Bearer ` + JSON.parse(localStorage.getItem('currentUser'))
    });
    return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/visits/${visitId}`, model, { headers: customHeader });
  }
}
